import React from 'react';
import { Alert as BootstrapAlert } from 'react-bootstrap';

const Alert = ({ 
    children, 
    variant = 'info', 
    dismissible = false, 
    onClose,
    show = true,
    heading,
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    if (!show) return null;
    
    return (
        <BootstrapAlert 
            variant={variant} 
            dismissible={dismissible} 
            onClose={onClose}
            className={className} 
            style={style}
            {...props}
        >
            {heading && <BootstrapAlert.Heading>{heading}</BootstrapAlert.Heading>}
            {children}
        </BootstrapAlert>
    );
};

export default Alert;

